/**
 * 클라우드 세이브 스텁. Phase δ.1에서 완성:
 *   - syncFromCloud(): Firestore `/users/{uid}/progress` → 로컬 머지
 *   - pushToCloud(): 로컬 → Firestore. 충돌 시 필드별 max.
 *
 * 현재는 no-op로 안전하게 호출 가능. 본격 구현 전까지 콘솔에 흔적만.
 */
export async function syncFromCloud(): Promise<void> {
  console.log('[cloudsave] syncFromCloud — stub (Phase δ)');
}

export async function pushToCloud(): Promise<void> {
  console.log('[cloudsave] pushToCloud — stub (Phase δ)');
}

/** 부팅 직후 호출용 — 인증 완료 후 1회. */
export async function bootSync(): Promise<void> {
  await syncFromCloud();
}
